import styled from "@emotion/styled";

const OverflowedOptionWrapper = styled("div")`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { OverflowedOptionWrapper };
